<div class="cus-snakebar">
    <mat-icon>{{getIcon}}</mat-icon>
    &nbsp;
    <span>{{ data?.message }}</span>
    <div class="spacer"></div>
    <button class="btn" mat-button (click)="closeSnackbar()" >
        {{data.action}}
    </button>
</div>